export enum C4CFormTypes {
  TALEP = 'Talep',
  ONERI = 'Oneri',
  SIKAYET = 'Sikayet',
  TESEKKUR = 'Tesekkur',
}
